<template>
    <div class="dashboard-allotment" style="margin-top: 60px;">
        <load-screen :is-loading="isLoading"></load-screen>
        <div class="main-container">
            <div class="dashboard-hero">
                <div class="dashboard-hero__identity">
                    <span class="dashboard-hero__icon"><i class="icon-map"></i></span>
                    <div>
                        <span class="dashboard-hero__eyebrow">Loteamento</span>
                        <strong class="dashboard-hero__name">{{ nameAllotment || '—' }}</strong>
                    </div>
                </div>
                <div class="toolbar-select dashboard-hero__filter">
                            <span class="toolbar-select-label">
                                <i class="icon-grid"></i>
                                {{ t('NAV.ALLOTMENT_S') }}:
                            </span>
                    <div class="toolbar-select-control">
                        <Select2 :options="allotments"
                                 v-if="allotments?.length" class="align-self-center"
                                 v-model="allotmentId" @select="changeAllotment"
                                 :settings="{width:'100%'}" placeholder="Selecione"
                        ></Select2>
                    </div>
                </div>
            </div>
            <h5 class="dashboard-section-title" data-cy="allotment_dashboard_title_resum_lots">
                <i class="icon-map-pin"></i>Resumo de Lotes
            </h5>
            <div class="dashboard-stats-row">
                <div class="card dashboard-stat-card" v-for="iten in lots.lotsByStatus"
                     :key="iten.typeName" data-cy="allotment_dashboard_card_status">
                    <div class="dashboard-stat-card__top">
                        <span class="dashboard-stat-card__icon"><i class="icon-map-pin"></i></span>
                        <h3 class="dashboard-stat-card__value">{{ iten.total }}</h3>
                    </div>
                    <p class="dashboard-stat-card__label">{{ iten.typeName }}</p>
                    <div class="dashboard-stat-card__progress">
                        <span class="dashboard-stat-card__progress-fill"
                              :style="{width: ((iten.total / (lots.lots || 1)) * 100) + '%'}"></span>
                    </div>
                </div>
                <div class="card dashboard-stat-card" v-for="iten in lots.emptyStatus"
                     :key="iten.typeName" data-cy="allotment_dashboard_card_lot_emptystatus">
                    <div class="dashboard-stat-card__top">
                        <span class="dashboard-stat-card__icon"><i class="icon-map-pin"></i></span>
                        <h3 class="dashboard-stat-card__value">{{ 0 }}</h3>
                    </div>
                    <p class="dashboard-stat-card__label">{{ iten.typeName }}</p>
                    <div class="dashboard-stat-card__progress"></div>
                </div>
                <div class="card dashboard-stat-card dashboard-stat-card--total"
                     data-cy="allotment_dashboard_card_total_lotes">
                    <div class="dashboard-stat-card__top">
                        <span class="dashboard-stat-card__icon"><i class="icon-layers2"></i></span>
                        <h3 class="dashboard-stat-card__value">{{ lots.lots }}</h3>
                    </div>
                    <p class="dashboard-stat-card__label">Total Lotes</p>
                    <div class="dashboard-stat-card__progress">
                        <span class="dashboard-stat-card__progress-fill"
                              :style="{width: '100%'}"></span>
                    </div>
                </div>
            </div>
            <div class="card dashboard-chart-card">
                <div class="dashboard-chart-card__header">
                    <h5 class="card-title" data-cy="allotment_dashboard_title_lots_by_situation">Lotes por situação</h5>
                </div>
                <div class="main-container">
                    <div id="chartReserveType" :style="blurLoadingR"
                         data-cy="allotment_dashboard_chart_lots_by_situation"></div>
                </div>
                <div v-if="!loadingReserve" :class="{ loader: false, fadeout: !loadingReserve}"
                     class="dashboard-chart-loading">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
            <h5 class="dashboard-section-title" data-cy="allotment_dashboard_resum_reserve">
                <i class="icon-lock-open"></i>Resumo de Reservas
            </h5>
            <div class="dashboard-stats-row">
                <div class="card dashboard-stat-card" v-for="iten in reserves.reservesByType"
                     :key="iten.typeName" data-cy="allotment_dashboard_card_resum_reserve">
                    <div class="dashboard-stat-card__top">
                        <span class="dashboard-stat-card__icon"><i class="icon-lock-open"></i></span>
                        <h3 class="dashboard-stat-card__value">{{ iten.total }}</h3>
                    </div>
                    <p class="dashboard-stat-card__label">{{ iten.typeName }}</p>
                    <div class="dashboard-stat-card__progress">
                        <span class="dashboard-stat-card__progress-fill"
                              :style="{width: ((iten.total / (reserves.reservesTotal || 1)) * 100) + '%'}"></span>
                    </div>
                </div>
                <div class="card dashboard-stat-card dashboard-stat-card--total"
                     data-cy="allotment_dashboard_total_reserve">
                    <div class="dashboard-stat-card__top">
                        <span class="dashboard-stat-card__icon"><i class="icon-layers2"></i></span>
                        <h3 class="dashboard-stat-card__value">{{ reserves.reservesTotal }}</h3>
                    </div>
                    <p class="dashboard-stat-card__label">Total Reservas</p>
                    <div class="dashboard-stat-card__progress">
                        <span class="dashboard-stat-card__progress-fill"
                              :style="{width: '100%'}"></span>
                    </div>
                </div>
            </div>
            <div class="card dashboard-chart-card">
                <div class="dashboard-chart-card__header">
                    <h5 class="card-title" data-cy="allotment_dashboard_title_reserve">
                        {{ this.t('NAV.RESERVE') }}</h5>
                </div>
                <div class="main-container">
                    <div id="chartReserve" :style="blurLoadingR"
                         data-cy="allotment_dashboard_chart_reserve"></div>
                </div>
                <div v-if="!loadingReserve" :class="{ loader: false, fadeout: !loadingReserve}"
                     class="dashboard-chart-loading">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {useToast} from "vue-toastification";
import {useI18n} from "vue-i18n";
import ApexChartss from "apexcharts";
import LoadScreen from "@/components/layouts/loadScreenComponent";
import Dashboard from "../../services/Dashboard";
import {mapState} from "vuex";
import Select2 from 'vue3-select2-component';

export default {
    name: "DashboardAllotment",
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    components: {
        LoadScreen,
        Select2,
    },
    data() {
        return {
            totalClients: 0,
            allotmentId: null,
            reserves: {},
            seriesReserve: [],
            chartReserve: null,
            chartOptionsReserve: {},
            loadingReserve: true,
            lots: {},
            series: [{
                data: [5, 2, 18, 20, 10, 5, 24, 20, 25, 17, 20, 22]
            }],
            chartOptions: {
                dataLabels: {
                    enabled: true
                },
                xaxis: {
                    categories: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
                        'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                },
                colors: ['#0e5e4e'],
            }
        }
    },
    async mounted() {
        this.$canAccess('Allotment_dashboard');
        this.allotmentId = this.$route.params.id;
        if (this.allotments?.length) {
            if (!this.allotments.find(i => i.id === this.$route.params.id)?.id) {
                this.$router.push({name: 'IndexAllotmant'});
            }
        }
        this.$store.commit('changeLoading', true);
        this.summaryLots();
        this.renderChartReserveType();
        this.renderChartReserve();
        await this.summaryReserves();
        this.$store.commit('changeLoading', false);
    },
    watch: {
        allotments() {
            if (!this.allotments.find(i => i.id === this.$route.params.id)?.id) {
                this.$router.push({name: 'IndexAllotmant'});
            }
        }
    },
    computed: {
        ...mapState({
            isLoading: 'isLoading',
            allotments: 'allotments',
        }),
        blurLoadingR() {
            if (!this.loadingReserve) {
                return '-webkit-filter: blur(5px)';
            }
            return '';
        },
        nameAllotment() {
            return this.allotments?.find(i => i.id === this.$route.params.id)?.text;
        },
    },
    methods: {
        changeAllotment({id}) {
            const path = this.$router.resolve({name: 'DashboardAllotment', params: {id}}).href;
            window.location.href = path;
        },
        renderChartReserveType() {
            Dashboard.resumReserveByType(this.$route.params.id).then(resp => {
                if (!resp.data?.statuses?.length) {
                    return;
                }
                let series = [];
                let categories = resp.data.categories;
                resp.data.statuses.forEach(statuse => {
                    if (statuse?.reserve_types?.length) {
                        return;
                    }
                    if (Array.isArray(statuse.data)) {
                        series.push({
                            name: statuse.name,
                            data: statuse.data,
                            color: statuse.color,
                        });
                    } else {
                        let d = [];
                        Object.keys(statuse.data).forEach((key) => {
                            d.push(statuse.data[key])
                        })
                        series.push({
                            name: statuse.name,
                            data: d,
                            color: statuse.color,
                        });
                    }
                })
                let options = {
                    series: series,
                    dataLabels: {
                        enabled: false,
                    },
                    chart: {
                        type: 'bar',
                        height: 350,
                        stacked: true,
                        toolbar: {
                            show: true
                        },
                        zoom: {
                            enabled: true
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            dataLabels: {
                                total: {
                                    enabled: true,
                                    style: {
                                        fontSize: '13px',
                                        fontWeight: 900
                                    }
                                }
                            }
                        },
                    },
                    xaxis: {
                        type: 'string',
                        categories: categories,
                    },
                }
                var chart = new ApexChartss(document.getElementById("chartReserveType"), options);
                chart.render();
            })
        },
        summaryLots() {
            Dashboard.summaryLotsByAllotment(this.$route.params.id).then(resp => {
                this.lots = resp.data;
            })
        },
        async summaryReserves() {
            await Dashboard.summaryReservesByAllotment(this.$route.params.id).then(resp => {
                this.reserves = resp.data;
            })
        },
        getClients() {
            Dashboard.getClients().then((resp) => {
                this.totalClients = resp.data.total;
            }).catch(() => {
            })
        },
        async renderChartReserve(companyId) {
            companyId = localStorage.getItem('companyId');
            Dashboard.datasAnualReserve(companyId, this.$route.params.id).then(resp => {
                if (this.chartReserve) {
                    this.chartReserve.destroy();
                }
                let result = resp.data
                this.seriesReserve = [];

                this.seriesReserve.push({
                    name: result.name1,
                    data: result.reserves
                });

                this.seriesReserve.push({
                    name: result.name2,
                    data: result.reservesConfirmed
                });

                this.chartOptionsReserve = {
                    chart: {
                        height: '280',
                        type: 'area',
                        width: '100%',
                        defaultLocale: 'pt',
                        locales: [{
                            name: 'pt',
                            options: {
                                toolbar: {
                                    download: 'Download SVG',
                                    selection: 'Selecionar',
                                    selectionZoom: 'Selecionar Zoom',
                                    zoomIn: 'Aumentar Zoom',
                                    zoomOut: 'Reduzir Zoom',
                                    pan: 'Panorama',
                                    reset: 'Resetar Zoom',
                                }
                            }
                        }],
                    },
                    noData: {
                        text: 'Nenhum dado para ser carregado',
                        align: 'center',
                        verticalAlign: 'middle',
                    },

                    series: this.seriesReserve,
                    xaxis: {
                        convertedCatToNumeric: false,
                        categories: result.categories
                    },
                    colors: ['#0e5e4e', '#0FBC9A', '#23A88D'],
                }

                let elChartReserve = document.getElementById('chartReserve');
                this.chartReserve = new ApexChartss(elChartReserve, this.chartOptionsReserve);
                this.chartReserve.render();
                this.loadingReserve = true
            }).catch(() => {
                this.loadingReserve = true
            });
        },
    }
}
</script>

<style scoped>
.dashboard-hero {
    align-items: center;
    background:
        radial-gradient(ellipse at 0% 0%, rgba(14, 94, 78, 0.10), transparent 55%),
        linear-gradient(135deg, #edf8f5 0%, #ffffff 100%);
    border: 1px solid #cfe5df;
    border-radius: 16px;
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.85),
        0 14px 32px rgba(15, 23, 42, 0.07);
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    padding: 1.1rem 1.25rem;
}

.dashboard-hero__identity {
    align-items: center;
    display: flex;
    gap: 0.85rem;
    min-width: 0;
}

.dashboard-hero__icon {
    align-items: center;
    background: #0e5e4e;
    border-radius: 14px;
    box-shadow: 0 10px 22px rgba(14, 94, 78, 0.25);
    color: #ffffff;
    display: inline-flex;
    flex: 0 0 46px;
    font-size: 1.25rem;
    height: 46px;
    justify-content: center;
    width: 46px;
}

.dashboard-hero__eyebrow {
    color: #0e5e4e;
    display: block;
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.dashboard-hero__name {
    color: #173b34;
    display: block;
    font-size: 1.15rem;
    font-weight: 800;
    line-height: 1.25;
}

.dashboard-hero__filter {
    margin: 0;
    min-width: 280px;
}

.dashboard-section-title {
    align-items: center;
    border-left: 4px solid #0e5e4e;
    color: #173b34;
    display: flex;
    font-size: 1rem;
    font-weight: 800;
    gap: 0.5rem;
    margin: 1.25rem 0 0.75rem;
    padding-left: 0.65rem;
}

.dashboard-section-title i {
    color: #0e5e4e;
    font-size: 1.05rem;
}

.dashboard-stats-row {
    display: grid;
    gap: 0.75rem;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
}

.dashboard-stat-card {
    padding: 0.9rem 0.95rem;
}

.dashboard-stat-card__top {
    align-items: center;
    display: flex;
    gap: 0.65rem;
    margin-bottom: 0.55rem;
}

.dashboard-stat-card__icon {
    align-items: center;
    background: #e7f4f0;
    border-radius: 11px;
    color: #0e5e4e;
    display: inline-flex;
    flex: 0 0 34px;
    font-size: 0.95rem;
    height: 34px;
    justify-content: center;
    width: 34px;
}

.dashboard-stat-card__value {
    color: #173b34;
    font-size: 1.45rem;
    font-weight: 800;
    line-height: 1;
    margin-bottom: 0;
}

.dashboard-stat-card__label {
    color: #6b7c78;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    line-height: 1.25;
    margin-bottom: 0.65rem;
    min-height: 1.8em;
    text-transform: uppercase;
}

.dashboard-stat-card__progress {
    background: #e6edf2;
    border-radius: 999px;
    height: 5px;
    overflow: hidden;
}

.dashboard-stat-card__progress-fill {
    background: linear-gradient(90deg, #0e5e4e, #14b8a6);
    border-radius: 999px;
    display: block;
    height: 100%;
    transition: width 0.4s ease;
}

.dashboard-stat-card--total {
    background: linear-gradient(135deg, #0e5e4e 0%, #12816b 100%);
    border: 0;
    box-shadow: 0 14px 28px rgba(14, 94, 78, 0.28);
}

.dashboard-stat-card--total .dashboard-stat-card__icon {
    background: rgba(255, 255, 255, 0.16);
    color: #ffffff;
}

.dashboard-stat-card--total .dashboard-stat-card__value {
    color: #ffffff;
}

.dashboard-stat-card--total .dashboard-stat-card__label {
    color: rgba(255, 255, 255, 0.78);
}

.dashboard-stat-card--total .dashboard-stat-card__progress {
    background: rgba(255, 255, 255, 0.18);
}

.dashboard-stat-card--total .dashboard-stat-card__progress-fill {
    background: #ffffff;
}

.dashboard-chart-card {
    border-radius: 14px;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
    margin-bottom: 0.5rem;
    margin-top: 0.75rem;
    padding: 1rem 1rem 0.5rem;
}

.dashboard-chart-card__header {
    border-bottom: 1px solid rgba(14, 94, 78, 0.12);
    margin-bottom: 0.75rem;
    padding-bottom: 0.6rem;
}

.dashboard-chart-card__header .card-title {
    color: #173b34;
    font-size: 0.98rem;
    font-weight: 800;
    margin-bottom: 0;
}

.dashboard-chart-loading {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 1.5rem 0;
}

html.dark-theme .dashboard-hero {
    background:
        radial-gradient(ellipse at 0% 0%, rgba(20, 184, 166, 0.18), transparent 55%),
        linear-gradient(135deg, rgba(17, 24, 39, 0.98) 0%, rgba(23, 32, 51, 0.96) 100%) !important;
    border-color: rgba(94, 234, 212, 0.18) !important;
}

html.dark-theme .dashboard-hero__icon {
    background: #14b8a6 !important;
}

html.dark-theme .dashboard-hero__eyebrow {
    color: #5eead4 !important;
}

html.dark-theme .dashboard-hero__name {
    color: var(--dark-text) !important;
}

html.dark-theme .dashboard-section-title {
    border-left-color: #14b8a6 !important;
    color: var(--dark-text) !important;
}

html.dark-theme .dashboard-section-title i {
    color: #5eead4 !important;
}

html.dark-theme .dashboard-stat-card__icon {
    background: var(--dark-primary-soft) !important;
    color: #5eead4 !important;
}

html.dark-theme .dashboard-stat-card__value {
    color: var(--dark-text) !important;
}

html.dark-theme .dashboard-stat-card__label {
    color: var(--dark-text-muted) !important;
}

html.dark-theme .dashboard-stat-card__progress {
    background: rgba(148, 163, 184, 0.16) !important;
}

html.dark-theme .dashboard-stat-card--total {
    background: linear-gradient(135deg, #0d9488 0%, #14b8a6 100%) !important;
}

html.dark-theme .dashboard-chart-card {
    border-color: var(--dark-border) !important;
}

html.dark-theme .dashboard-chart-card__header {
    border-bottom-color: rgba(94, 234, 212, 0.14) !important;
}

html.dark-theme .dashboard-chart-card__header .card-title {
    color: var(--dark-text) !important;
}

@media (max-width: 575px) {
    .dashboard-hero__filter {
        min-width: 100%;
    }
}
</style>
